import { TaxReportComponent } from './tax-report.component';
export var taxReportRoutes = [
    {
        path: 'taxReport',
        component: TaxReportComponent
    },
];
var TaxReportRoutingModule = (function () {
    function TaxReportRoutingModule() {
    }
    return TaxReportRoutingModule;
}());
export { TaxReportRoutingModule };



// WEBPACK FOOTER //
// /opt/app/src/app/features/tax-report/tax-report-routing.module.ts.pre-build-optimizer.js